export default {
  logoBlue: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width="179"
      height="50"
      viewBox="0 0 179 50"
    >
      <path
        fill="#5F6FFF"
        fillRule="evenodd"
        d="M18.636.765a.745.745 0 00-.777-.744C8.176.416.399 8.184 0 17.855a.748.748 0 00.747.777h5.454c0-6.858 5.567-12.418 12.434-12.418V.766zM18.636 48.917c0 .423.354.762.778.744 9.682-.396 17.458-8.163 17.857-17.832a.75.75 0 00-.748-.779H31.07c0 6.859-5.567 12.418-12.434 12.418v5.45zM18.636 12.423a6.213 6.213 0 00-6.216 6.209h6.216v-6.209zM18.636 37.26a6.213 6.213 0 006.216-6.21h-6.216v6.21zM18.636 37.259a6.215 6.215 0 00-6.16 5.37c-.06.444.293.839.742.839h5.418v-6.209z"
        clipRule="evenodd"
      />
      <path
        fill="#5F6FFF"
        fillRule="evenodd"
        d="M31.069 31.05c0-6.859-5.567-12.418-12.433-12.418v6.209a6.212 6.212 0 016.216 6.209h6.217zM6.202 18.632c0 6.859 5.567 12.418 12.433 12.418v-6.209a6.212 6.212 0 01-6.216-6.209H6.202zM18.635 12.422V6.213h5.419c.45 0 .803.395.742.84a6.215 6.215 0 01-6.161 5.369z"
        clipRule="evenodd"
      />
      <path
        fill="#0E1C6B"
        fillRule="evenodd"
        d="M49.72 34.177c0-.13 0-.3.086-.428l1.457-2.698c.172-.342.515-.472.814-.472.173 0 .301 0 .472.087.858.514 3.044 1.412 5.874 1.412 1.415 0 3.345-.6 3.345-1.627 0-2.912-11.919-2.527-11.919-10.662 0-4.54 3.172-7.324 8.875-7.324 2.701 0 6.002 1.071 7.332 1.671.171.13.429.343.514.771 0 .129 0 .3-.042.47l-1.373 3.17c-.128.257-.557.6-.9.6l-.472-.13c-1.071-.3-3.644-.899-4.931-.899-2.786 0-3 1.371-3 1.67 0 2.913 11.92 3.083 11.92 10.62 0 4.411-5.19 6.894-8.748 6.894-2.787 0-5.875-.513-8.832-2.312-.173-.086-.472-.514-.472-.813zM82.818 28.01v8.18a.879.879 0 01-.9.898h-4.202c-.558 0-.901-.386-.901-.899V28.01l-8.532-14.131c0-.685.428-1.113 1.029-1.113h4.074c.77 0 1.2.428 1.371.942l5.06 8.264 5.059-8.264c.171-.514.6-.942 1.371-.942h4.074c.6 0 1.029.428 1.029 1.113L82.818 28.01zM93.278 13.365c0-.514.429-.856 1.115-.856l14.106 9.078V14.05c0-.727.515-1.284 1.287-1.284h3.43c.73 0 1.286.557 1.286 1.284v22.14c0 .514-.386.899-.9.899H109.4c-.558 0-.9-.386-.9-.9V28.78l-9.219-6.037v13.446c0 .514-.386.9-.9.9h-4.202c-.557 0-.9-.386-.9-.9V13.365zM118.36 34.177c0-.13 0-.3.085-.428l1.459-2.698c.171-.342.515-.472.815-.472.17 0 .299 0 .471.087.857.514 3.044 1.412 5.873 1.412 1.414 0 3.345-.6 3.345-1.627 0-2.912-11.92-2.527-11.92-10.662 0-4.54 3.172-7.324 8.875-7.324 2.702 0 6.003 1.071 7.332 1.671.173.13.429.343.515.771 0 .129 0 .3-.043.47l-1.372 3.17c-.129.257-.557.6-.9.6l-.471-.13c-1.073-.3-3.645-.899-4.932-.899-2.786 0-3.002 1.371-3.002 1.67 0 2.913 11.921 3.083 11.921 10.62 0 4.411-5.188 6.894-8.747 6.894-2.787 0-5.874-.513-8.832-2.312-.172-.086-.472-.514-.472-.813zM153.94 22.228a.88.88 0 01.901.9v3.853c0 .557-.386.9-.901.9h-8.233v3.555h10.462c.515 0 .9.384.9.898v3.855c0 .556-.385.898-.9.898h-15.564a.879.879 0 01-.9-.898V13.664c0-.514.385-.9.9-.9h15.564c.515 0 .9.386.9.9v3.982c0 .557-.385.9-.9.9h-10.462v3.682h8.233z"
        clipRule="evenodd"
      />
      <mask
        id="a"
        width="19"
        height="26"
        x="160"
        y="12"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M160.93 12.766h17.364v24.321H160.93V12.766z"
          clipRule="evenodd"
        />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#0E1C6B"
          fillRule="evenodd"
          d="M160.93 13.664c0-.514.344-.899.901-.899h4.202c.514 0 .9.385.9.899v17.813h10.461a.88.88 0 01.901.9v3.811c0 .556-.386.898-.901.898h-15.563c-.557 0-.901-.385-.901-.898V13.663z"
          clipRule="evenodd"
        />
      </g>
    </svg>
  ),
  logoBlueSm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width="140"
      height="40"
      viewBox="0 0 140 40"
    >
      <path
        fill="#5F6FFF"
        d="M14.598 1.384a.584.584 0 00-.609-.583C6.404 1.11.312 7.203 0 14.788a.586.586 0 00.586.61h4.272c0-5.38 4.36-9.74 9.74-9.74V1.384zm0 37.766c0 .332.278.598.61.583 7.584-.31 13.675-6.402 13.988-13.986a.587.587 0 00-.587-.61h-4.271c0 5.379-4.36 9.739-9.74 9.739v4.274zm0-28.622a4.87 4.87 0 00-4.87 4.87h4.87v-4.87zm0 19.479a4.87 4.87 0 004.87-4.87h-4.87v4.87z"
      />
      <path
        fill="#5F6FFF"
        d="M14.598 30.007a4.87 4.87 0 00-4.826 4.211.585.585 0 00.582.659h4.244v-4.87zm9.74-4.87c0-5.38-4.36-9.74-9.74-9.74v4.87a4.87 4.87 0 014.87 4.87h4.87zm-19.48-9.739c0 5.38 4.361 9.74 9.74 9.74v-4.87a4.87 4.87 0 01-4.87-4.87h-4.87zm9.74-4.871v-4.87h4.245c.352 0 .629.31.581.66a4.87 4.87 0 01-4.826 4.21z"
      />
      <path
        fill="#0E1C6B"
        d="M38.948 27.589c0-.102 0-.235.067-.336l1.142-2.116c.134-.268.403-.37.637-.37.136 0 .236 0 .37.068.672.404 2.385 1.108 4.602 1.108 1.108 0 2.62-.47 2.62-1.276 0-2.284-9.337-1.982-9.337-8.363 0-3.56 2.485-5.744 6.952-5.744 2.116 0 4.701.84 5.743 1.31a.959.959 0 01.403.605c0 .101 0 .235-.033.37l-1.076 2.485c-.1.201-.436.47-.705.47l-.369-.1c-.84-.236-2.854-.706-3.863-.706-2.183 0-2.35 1.075-2.35 1.31 0 2.284 9.337 2.418 9.337 8.329 0 3.46-4.065 5.407-6.852 5.407-2.183 0-4.602-.402-6.918-1.813-.136-.068-.37-.404-.37-.638zm25.927-4.836v6.415a.689.689 0 01-.706.705h-3.29c-.438 0-.706-.302-.706-.705v-6.415L53.489 11.67c0-.538.336-.873.806-.873h3.191c.604 0 .94.335 1.075.739l3.964 6.481 3.962-6.481c.134-.404.47-.739 1.074-.739h3.192c.47 0 .805.335.805.873l-6.683 11.083zm8.193-11.487c0-.403.336-.671.874-.671l11.05 7.12v-5.912c0-.57.403-1.007 1.008-1.007h2.686a.99.99 0 011.008 1.007v17.364a.689.689 0 01-.706.705h-3.29c-.438 0-.706-.302-.706-.705v-5.81L77.77 18.62v10.546a.689.689 0 01-.706.706h-3.291c-.437 0-.706-.303-.706-.706v-17.9zm19.646 16.323c0-.102 0-.235.067-.336l1.143-2.116c.134-.268.403-.37.638-.37.134 0 .234 0 .369.068.671.404 2.385 1.108 4.6 1.108 1.109 0 2.62-.47 2.62-1.276 0-2.284-9.336-1.982-9.336-8.363 0-3.56 2.485-5.744 6.952-5.744 2.116 0 4.703.84 5.743 1.31a.956.956 0 01.404.605c0 .101 0 .235-.034.37l-1.074 2.485c-.102.201-.437.47-.706.47l-.37-.1c-.84-.236-2.854-.706-3.862-.706-2.183 0-2.352 1.075-2.352 1.31 0 2.284 9.338 2.418 9.338 8.329 0 3.46-4.064 5.407-6.852 5.407-2.182 0-4.6-.402-6.918-1.813-.135-.068-.37-.404-.37-.638zm27.876-9.371c.404 0 .706.302.706.706v3.022c0 .437-.302.706-.706.706h-6.448v2.788h8.195c.403 0 .705.301.705.704v3.024c0 .436-.302.704-.705.704h-12.192a.689.689 0 01-.705-.704V11.502c0-.404.302-.706.705-.706h12.192c.403 0 .705.302.705.706v3.123c0 .437-.302.705-.705.705h-8.195v2.888h6.448z"
      />
      <mask
        id="a"
        width="14"
        height="20"
        x="126"
        y="10"
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="#fff"
          d="M126.06 10.797h13.602v19.075H126.06V10.797z"
        />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#0E1C6B"
          d="M126.06 11.501c0-.403.27-.705.706-.705h3.291c.403 0 .705.302.705.705v13.971h8.195c.403 0 .705.302.705.706v2.99c0 .435-.302.703-.705.703h-12.191c-.436 0-.706-.301-.706-.704V11.501z"
        />
      </g>
    </svg>
  ),
  logoWhiteSm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="140"
      height="40"
      viewBox="0 0 140 40"
    >
      <path
        fill="#fff"
        d="M14.626 5.658V1.384a.584.584 0 00-.61-.583C6.428 1.11.333 7.203.02 14.788a.587.587 0 00.586.61H4.88c0-5.38 4.364-9.74 9.747-9.74m-.001 29.219v4.274c0 .332.278.597.61.583 7.589-.31 13.684-6.403 13.997-13.986a.587.587 0 00-.587-.61h-4.274c0 5.379-4.363 9.739-9.746 9.739m0-24.349a4.871 4.871 0 00-4.873 4.87h4.873v-4.87zm0 19.479a4.872 4.872 0 004.873-4.87h-4.873v4.87z"
      />
      <path
        fill="#fff"
        d="M14.626 30.007a4.872 4.872 0 00-4.829 4.211.585.585 0 00.582.659h4.247v-4.87zm4.873-4.87h4.873c0-5.38-4.364-9.74-9.746-9.74v4.87a4.87 4.87 0 014.873 4.87m-9.746-9.739H4.88c0 5.38 4.364 9.74 9.745 9.74v-4.87a4.87 4.87 0 01-4.872-4.87m4.872-4.871v-4.87h4.247c.353 0 .63.31.582.66a4.872 4.872 0 01-4.829 4.21zM38.99 27.589c0-.102 0-.235.067-.336l1.142-2.116c.135-.268.404-.37.639-.37.135 0 .236 0 .37.068.672.404 2.386 1.108 4.604 1.108 1.109 0 2.622-.47 2.622-1.276 0-2.284-9.343-1.982-9.343-8.363 0-3.56 2.486-5.744 6.956-5.744 2.117 0 4.705.84 5.747 1.31a.959.959 0 01.403.605c0 .101 0 .235-.033.37l-1.076 2.485c-.1.201-.436.47-.706.47l-.37-.1c-.839-.236-2.855-.706-3.865-.706-2.184 0-2.352 1.075-2.352 1.31 0 2.284 9.344 2.418 9.344 8.329 0 3.46-4.067 5.407-6.856 5.407-2.185 0-4.605-.402-6.923-1.813-.135-.068-.37-.404-.37-.638m25.944-4.836v6.415a.689.689 0 01-.706.705h-3.293c-.437 0-.706-.302-.706-.705v-6.415L53.54 11.67c0-.538.336-.873.806-.873h3.194c.604 0 .94.335 1.075.739l3.966 6.481 3.965-6.481c.134-.404.47-.739 1.075-.739h3.193c.471 0 .806.335.806.873l-6.687 11.083zm8.198-11.487c0-.403.336-.671.874-.671l11.056 7.12v-5.912c0-.57.404-1.007 1.009-1.007h2.688a.99.99 0 011.009 1.007v17.364a.69.69 0 01-.706.705h-3.294c-.437 0-.706-.302-.706-.705v-5.81l-7.225-4.736v10.546a.69.69 0 01-.706.706h-3.293c-.437 0-.706-.303-.706-.706v-17.9zm19.659 16.323c0-.102 0-.235.067-.336l1.143-2.116c.135-.268.404-.37.64-.37.133 0 .234 0 .368.068.672.404 2.387 1.108 4.604 1.108 1.109 0 2.622-.47 2.622-1.276 0-2.284-9.343-1.982-9.343-8.363 0-3.56 2.486-5.744 6.956-5.744 2.118 0 4.706.84 5.747 1.31a.956.956 0 01.403.605c0 .101 0 .235-.033.37l-1.075 2.485c-.102.201-.437.47-.706.47l-.369-.1c-.841-.236-2.857-.706-3.866-.706-2.184 0-2.353 1.075-2.353 1.31 0 2.284 9.344 2.418 9.344 8.329 0 3.46-4.067 5.407-6.856 5.407-2.184 0-4.604-.402-6.923-1.813-.135-.068-.37-.404-.37-.638m27.889-9.371a.69.69 0 01.707.706v3.022c0 .437-.303.706-.707.706h-6.452v2.788h8.2c.403 0 .705.301.705.704v3.024c0 .436-.302.704-.705.704h-12.2a.689.689 0 01-.705-.704V11.502c0-.404.302-.706.705-.706h12.2c.403 0 .705.302.705.706v3.123c0 .437-.302.705-.705.705h-8.2v2.888h6.452zm5.48-6.717c0-.403.27-.705.706-.705h3.294a.69.69 0 01.706.705v13.971h8.199c.404 0 .706.302.706.706v2.99c0 .435-.302.703-.706.703h-12.199c-.436 0-.706-.301-.706-.704V11.501z"
      />
    </svg>
  ),
  qroCircleDarkOpen: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="145"
      height="145"
      fill="none"
      version="1.1"
      viewBox="0 0 145 145"
    >
      <path
        stroke="#0e1c6b"
        d="M94.563 108.5A143.726 143.726 0 01.996 143.998V.996h142.981a177.19 177.19 0 01-1.467 18.509A144.079 144.079 0 0194.563 108.5z"
      />
    </svg>
  ),
  qrbCircleDarkOpen: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="160"
      height="160"
      fill="none"
      version="1.1"
      viewBox="0 0 160 160"
    >
      <path
        stroke="#0e1c6b"
        d="M120.164 55.346A158.977 158.977 0 01159.499 159.5H.5V.516a214.737 214.737 0 015.985.305c3.969.258 9.366.71 15.086 1.485 38.21 5.205 73.235 24.047 98.594 53.04z"
      />
    </svg>
  ),
  lqrbCircleOpen: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="320"
      height="320"
      preserveAspectRatio="xMidYMid meet"
      version="1"
      viewBox="0 0 240 240"
    >
      <g
        fill="none"
        fillOpacity="1"
        stroke="#606af8"
        strokeDasharray="none"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="31.069"
        transform="rotate(90 119.252 120) scale(.04828)"
      >
        <path
          fill="none"
          fillOpacity="1"
          stroke="#606af8"
          strokeDasharray="none"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="31.069"
          d="M0 4893c0-92 21-389 36-523 105-920 471-1794 1060-2528 502-627 1184-1141 1934-1457 400-169 900-299 1340-349 134-15 431-36 523-36h47v2470h-78c-98 0-298 23-427 50-264 54-531 159-765 300-331 199-648 513-843 835-212 351-338 755-354 1143l-6 142H0z"
        />
      </g>
    </svg>
  ),
  lqlbCircleOpen: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="320"
      height="320"
      preserveAspectRatio="xMidYMid meet"
      version="1"
      viewBox="0 0 240 240"
    >
      <g
        fill="none"
        fillOpacity="1"
        stroke="#606af8"
        strokeDasharray="none"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="31.069"
        transform="matrix(.04828 0 0 .04828 .75 .75)"
      >
        <path
          fill="none"
          fillOpacity="1"
          stroke="#606af8"
          strokeDasharray="none"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="31.069"
          d="M0 4893c0-92 21-389 36-523 105-920 471-1794 1060-2528 502-627 1184-1141 1934-1457 400-169 900-299 1340-349 134-15 431-36 523-36h47v2470h-78c-98 0-298 23-427 50-264 54-531 159-765 300-331 199-648 513-843 835-212 351-338 755-354 1143l-6 142H0z"
        />
      </g>
    </svg>
  ),
  qrbCircle: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="280"
      height="280"
      preserveAspectRatio="xMidYMid meet"
      version="1"
      viewBox="0 0 210 210"
    >
      <g
        fill="#606af8"
        fillOpacity="1"
        stroke="none"
        transform="matrix(.08495 0 0 -.08495 0 210)"
      >
        <path
          fill="#606af8"
          fillOpacity="1"
          d="M0 1236V0h2472l-6 108c-40 647-283 1198-722 1636-438 439-989 682-1636 722l-108 6z"
        />
      </g>
    </svg>
  ),
  lqkbCircleDark: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="320"
      height="320"
      fill="none"
      version="1.1"
      viewBox="0 0 320 320"
    >
      <path
        fill="#0e1c6b"
        d="M319.923 160.013V0a319.87 319.87 0 00-226.21 93.724A320.076 320.076 0 000 320h160.038a160.004 160.004 0 0146.854-113.137 159.929 159.929 0 0151.895-34.68A159.89 159.89 0 01320 160.014"
      />
    </svg>
  ),
  aboutHeaderDecorLeft: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="754"
      height="1130"
      fill="none"
      version="1.1"
      viewBox="0 0 754 1130"
    >
      <path
        fill="#606af8"
        fillRule="evenodd"
        d="M565 188.169V.219s-10.729-.505-23.568.02C248.015 12.268 12.308 247.973.246 541.366-.294 554.24.224 565 .224 565h187.94c0-208.115 168.718-376.831 376.836-376.831z"
        clipRule="evenodd"
      />
      <path
        fill="#606af8"
        fillRule="evenodd"
        d="M565.163 1130c103.841 0 188-84.176 188-188h-188z"
        clipRule="evenodd"
      />
      <path
        fill="#606af8"
        fillRule="evenodd"
        d="M565 376.169c95.577 0 174.565-70.76 187.046-162.562 1.831-13.48 1.954-25.438 1.954-25.438H565z"
        clipRule="evenodd"
      />
      <path
        fill="#606af8"
        fillRule="evenodd"
        d="M376.663 565h-188.5c0 208.208 168.784 377 377 377V753.491c-104.1 0-188.5-84.379-188.5-188.491z"
        clipRule="evenodd"
      />
    </svg>
  ),
  aboutHeaderDecorRight: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="941"
      height="752"
      fill="none"
      version="1.1"
      viewBox="0 0 941 752"
    >
      <path
        fill="#606af8"
        fillRule="evenodd"
        d="M941.015 376c0-103.841-84.176-188-188-188v188z"
        clipRule="evenodd"
      />
      <path
        fill="#606af8"
        fillRule="evenodd"
        d="M188 375c0-94.983-70.759-173.48-162.563-185.885C11.957 187.295 0 187 0 187v188z"
        clipRule="evenodd"
      />
      <path
        fill="#606af8"
        fillRule="evenodd"
        d="M753 188V0C545.344 0 377 168.337 377 376h188.008c0-103.824 84.156-188 187.992-188z"
        clipRule="evenodd"
      />
      <path
        fill="#606af8"
        fillRule="evenodd"
        strokeWidth="1"
        d="M377.015 564.001V752c207.656 0 376-168.336 376-376H565.008c0 103.825-84.157 188.001-187.993 188.001z"
        clipRule="evenodd"
      />
    </svg>
  ),
  aboutContentDecor1: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="188"
      height="188"
      fill="none"
      viewBox="0 0 188 188"
    >
      <path
        fill="#606AF8"
        fillRule="evenodd"
        d="M188 188C188 84.16 103.825 0 0 0v188h188z"
        clipRule="evenodd"
      />
    </svg>
  ),
  aboutContentDecor2: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="377"
      height="377"
      fill="none"
      viewBox="0 0 377 377"
    >
      <path
        fill="#606AF8"
        fillRule="evenodd"
        d="M188.5 0H0c0 208.208 168.784 377 377 377V188.491c-104.101 0-188.5-84.379-188.5-188.491"
        clipRule="evenodd"
      />
    </svg>
  ),
  aboutContentDecor3: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="189"
      height="190"
      fill="none"
      viewBox="0 0 189 190"
    >
      <path
        stroke="#606AF8"
        d="M188 189H0V1.008s11.956-.22 25.435 1.604C117.23 15.035 188 93.744 188 189"
      />
    </svg>
  ),
  chatDecor:
    'data:image/png;base64,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',
  cardDecor:
    'data:image/svg+xml;base64,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',
  workHeaderDecor1: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="268"
      height="267"
      fill="none"
      viewBox="0 0 268 267"
    >
      <path
        fill="#606AF8"
        fillRule="evenodd"
        d="M267.502 266.575c0-134.657-100.313-245.94-230.463-263.53C17.928.469.975.049.975.049v266.527h266.527z"
        clipRule="evenodd"
      />
    </svg>
  ),
  workHeaderDecor2: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="534"
      height="535"
      fill="none"
      viewBox="0 0 534 535"
    >
      <path
        fill="#606AF8"
        fillRule="evenodd"
        d="M266.944.575H0C0 295.43 239.024 534.467 533.892 534.467V267.508c-147.423 0-266.948-119.494-266.948-266.933z"
        clipRule="evenodd"
      />
    </svg>
  ),
  workContentDecor1: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="268"
      height="269"
      fill="none"
      viewBox="0 0 268 269"
    >
      <path
        fillRule="evenodd"
        stroke="#606AF8"
        strokeWidth="2"
        d="M1.473 267.994C148.688 267.994 268 148.656 268 1.467H1.473v266.527z"
        clipRule="evenodd"
      />
    </svg>
  ),
  workContentDecor2: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="535"
      height="537"
      fill="none"
      viewBox="0 0 535 537"
    >
      <path
        stroke="#606AF8"
        strokeWidth="2"
        d="M266.944 1.575H0C0 296.43 239.024 535.467 533.892 535.467V268.508c-147.423 0-266.948-119.494-266.948-266.933"
      />
    </svg>
  ),
  workContentDecor3: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="904"
      height="903"
      fill="none"
      viewBox="0 0 904 903"
    >
      <path
        stroke="#606AF8"
        strokeWidth="2"
        d="M1.744 601.515v299.394s16.887.805 37.51-.038C506.566 881.705 882 506.226 901.183 38.851 902.021 18.37 904 1.255 904 1.255H601.889c0 331.505-268.703 600.259-600.145 600.259"
      />
    </svg>
  ),
  qroCircleWhiteOpen: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="321"
      height="321"
      fill="none"
      version="1.1"
      viewBox="0 0 321 321"
    >
      <mask id="path-1-inside-1_107_28556" fill="#fff">
        <path d="M320.077 160.017V0A320.099 320.099 0 0093.748 93.736 320.01 320.01 0 000 320.033h160.038c0-42.439 16.861-83.14 46.874-113.149a160.054 160.054 0 01113.165-46.867z" />
      </mask>
      <path
        fill="#fff"
        d="M320.077 0h1v-1h-1v1zM0 320.033h-1v1h1v-1zm160.038 0v1h1v-1h-1zm161.039-160.016V0h-2v160.017h2zM320.077-1A321.1 321.1 0 0093.041 93.028l1.414 1.415A319.1 319.1 0 01320.077 1v-2zM93.041 93.028A321.011 321.011 0 00-1 320.033h2a319.012 319.012 0 0193.455-225.59l-1.414-1.415zM0 321.033h160.038v-2H0v2zm161.038-1c0-42.173 16.756-82.62 46.581-112.441l-1.414-1.415a161.01 161.01 0 00-47.167 113.856h2zm46.581-112.441a159.05 159.05 0 01112.458-46.575v-2a161.053 161.053 0 00-113.872 47.16l1.414 1.415z"
        mask="url(#path-1-inside-1_107_28556)"
      />
    </svg>
  ),
  jobDetailsDecorHero: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="873"
      height="873"
      fill="none"
      viewBox="0 0 873 873"
    >
      <path
        stroke="#5F6FFF"
        strokeWidth="2"
        d="M677.029 254.269a144.487 144.487 0 01-94.005 35.627V146.369h143.649a177.338 177.338 0 01-1.473 18.574 144.568 144.568 0 01-48.171 89.326z"
      />
      <path
        fill="#5F6FFF"
        d="M582.024 145.345V.185s-8.276-.394-18.198 0a436.427 436.427 0 00-290.373 127.508 436.675 436.675 0 00-127.454 290.465c-.417 9.948 0 18.249 0 18.249h145.117a291.105 291.105 0 0185.201-205.787 290.936 290.936 0 01205.707-85.275"
      />
      <path
        stroke="#5F6FFF"
        strokeWidth="2"
        d="M478.441 540.02a146.468 146.468 0 00102.582 42.915v143.532a289.878 289.878 0 01-109.972-22.071 289.963 289.963 0 01-94.079-62.877 290.066 290.066 0 01-84.923-204.112h143.49a146.548 146.548 0 0042.902 102.613z"
      />
      <path
        fill="#5F6FFF"
        d="M727.512 727.469H873a291.105 291.105 0 00-85.225-205.812 290.937 290.937 0 00-205.751-85.25v145.531a145.466 145.466 0 01102.875 42.625 145.55 145.55 0 0142.613 102.906z"
      />
      <path
        stroke="#5F6FFF"
        strokeWidth="2"
        d="M684.192 829.598a144.469 144.469 0 01-101.168 42.329V728.399h143.484a144.551 144.551 0 01-42.316 101.199zM37.085 531.604a144.579 144.579 0 01-35.64-94.011H144.93v143.478a152.243 152.243 0 01-18.55-1.307 144.498 144.498 0 01-89.295-48.16z"
      />
    </svg>
  ),
  jobDetailsDecorHeroMobile: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="96"
      height="96"
      fill="none"
      viewBox="0 0 96 96"
    >
      <path
        fill="#5F6FFF"
        d="M95.977 48.004V0a95.961 95.961 0 00-67.863 28.117A96.023 96.023 0 000 96h48.011a48.008 48.008 0 0114.056-33.941A47.979 47.979 0 0196 48.004"
      />
    </svg>
  ),
  applicationFormArrow: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="84"
      height="62"
      fill="none"
      viewBox="0 0 84 62"
    >
      <path
        fill="#fff"
        d="M80.095 19.888c.261.344.332.817.676 1.114.665.61 1.312.058 1.614-.637.09.05.16.098.249.149 1.031-2.59.076-5.635-.393-8.307-.579-3.286-1.315-6.535-2.03-9.8-.484-2.133-3.33-3.322-4.785-1.291-2.94 4.134-6.088 7.97-9.459 11.758-.492.534-.593 1.159-.483 1.773-.133.137-.285.271-.324.42l-.005.039-.002.019c-.191.574-.181.498-.165 1.1.02.137.034.178.086.359.056.297.174.564.37.822.197.239.4.44.689.575.243.186.536.283.858.307.19.006.403-.005.63.006.31-.017.574-.137.827-.316.283-.117.502-.32.687-.566.024-.036.032-.093.055-.128.166-.094.329-.17.465-.326.196-.186.38-.413.476-.71.024-.035.031-.092.055-.128.73-.31 1.405-.78 2.096-1.23-1.622 4.444-3.443 8.804-5.838 12.876a63.143 63.143 0 01-16.718 18.607C36.131 56.424 17.504 60.704.988 57.415c-.97-.186-1.102 1.246-.199 1.501 17.863 4.821 36.515 2.09 51.899-8.613 11.125-7.729 20.687-20.266 24.1-33.908.883 1.432 1.994 2.72 3.307 3.493z"
      />
    </svg>
  )
};
